import { Button } from "../ui/button";
import { ReactComponent as ArrowLeftSvg } from "@/assets/images/arrow-left.svg";
import { useNavigate } from "react-router-dom";

type Props = {
  url?: string;
  useBrowserBack?: boolean;
};

export default function HeaderBackButton({
  url = "/management/projects",
  useBrowserBack = false,
}: Props) {
  const navigate = useNavigate();

  const handleClick = () => {
    if (useBrowserBack) {
      navigate(-1);
    } else {
      navigate(url);
    }
  };

  return (
    <div>
      <Button
        variant="default"
        className="py-1 px-3 h-[25px] flex items-center gap-2 bg-white border-gray-D border-[1px] rounded-2xl text-gray-A text-sm font-semibold"
        onClick={handleClick}
      >
        <ArrowLeftSvg className="w-4 h-4" />
        뒤로가기
      </Button>
    </div>
  );
}
